/* The entry point.

   It does almost nothing on purpose. `app.js` still calls `boot()` on its last
   line, the way it always has, so importing it is enough to start the app —
   and keeping the entry separate from the app means the split in task #6 can
   move things out of `app.js` one module at a time without ever touching the
   thing index.html points at.

   The stylesheets are imported here rather than linked from the HTML so the
   bundler can see them: it rewrites the `url(...)` references inside them to
   the hashed filenames it emits, which is what makes the fonts and the
   template artwork survive a build. */

import '../styles.css';
import '../blank.css';
import '../bauhaus.css';
import '../swiss.css';
import '../neumorphism.css';
import '../glassmorphism.css';
import '../sketch.css';
import '../monochrome.css';
import '../darkglow.css';
import '../sprightly.css';

import './app.js';

/* Installable, and usable with no network.

   The registration is dynamic and its failure is swallowed on purpose. A
   service worker is an enhancement: it is unavailable over file:// , which is
   how the desktop shell loads the page, and refused outright in some private
   browsing modes. None of that should stop the app opening, so a failure here
   costs the offline cache and nothing else. */
if (__PWA__ && 'serviceWorker' in navigator) {
  import('virtual:pwa-register')
    .then(({ registerSW }) => registerSW({ immediate: true }))
    .catch(() => { /* no offline cache; the app is otherwise unaffected */ });
}
